import { emphasize } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  root: {
    '&&': {
      flexGrow: 1,
      marginTop: 16,
      marginBottom: 8,
    },
  },
  rootDense: {
    '&&': {
      flexGrow: 1,
      marginTop: 8,
      marginBottom: 4,
    },
  },
  noMargin: {
    '&&': {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  input: {
    '&&': {
      display: 'flex',
      padding: '10.5px 6px',
      paddingLeft: '14px',
      height: 'auto',
    },
  },
  inputDense: {
    '&&': {
      display: 'flex',
      padding: '2px',
      paddingLeft: '14px',
      height: 'auto',
    },
  },
  valueContainer: ({ isMulti, noWrap }) => {
    return {
      display: 'flex',
      flexWrap: isMulti && !noWrap ? 'wrap' : 'nowrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden',
    }
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  singleValue: ({ noWrap }) => {
    const style = {
      fontSize: 16,
    }
    if (noWrap) {
      style.textOverflow = 'ellipsis'
      style.whiteSpace = 'nowrap'
      style.width = '100%'
    }
    return style
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    bottom: 6,
    fontSize: 16,
  },
  paper: {
    '&&': {
      position: 'absolute',
      zIndex: 107,
      marginTop: theme.spacing(1),
      transform: 'translate3d(1px)',
      left: 0,
      backgroundColor: 'white',
      right: 0,
    },
  },
  divider: {
    height: theme.spacing(2),
  },
}))
